<template>
  <div class="mediagallery mt-3 mb-1" :class="media_gallery_class">
    <div class="gallery-item">
      <h3 class="media-gallery-title">
        {{ title }}
      </h3>
      <b-card class=" m-auto" :class="card_no_found_media_class" 
        align="center" no-body>
        <b-card-body align="center">
          <b-row align-v="center" class="h-100">
            <b-col>
              <h2 :class="no_found_media_text_class">
                {{ message }}
              </h2>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoMedia",
  props: ["title", "message", "media_gallery_class", 
    "card_no_found_media_class", "no_found_media_text_class"],
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/media/NoMediaCard.vue